import createReactComponent from '../createReactComponent';
var BookOpen = createReactComponent('BookOpen', [['path', {
  d: 'M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z',
  key: 'zkapdm'
}], ['path', {
  d: 'M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z',
  key: 'pggtc'
}]]);
export default BookOpen;